import React from 'react';
import DocumentVerificationStep from './DocumentVerificationStep';
import { OwnerDocumentKinds, StripeDocumentType } from '../../services/exports/Constants';

export default function OwnerDocumentStep(props) {
  return (
    <DocumentVerificationStep
      keyPrefix="Components:Verification:OwnerDocumentStep"
      documentType={StripeDocumentType.OwnerDocument}
      documentTypeOptions={OwnerDocumentKinds}
      {...props}
    />
  );
}
